import { adminUsersApiURL } from "API/urls/admin.api";
import { axiosInstance } from "configs/axios";

export const updateUserApi = async ({
  email,
  firstName,
  lastName,
  phoneNumber,
  userId,
  companyIds,
  deptId,
  mgrUserId,
}) => {
  try {
    const response = await axiosInstance.post(adminUsersApiURL.updateUser, {
      email,
      firstName,
      lastName,
      phoneNumber,
      userId,
      companyIds,
      deptId,
      mgrUserId,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
